<template>
    <div
        id="news_window"
        @touchmove.stop.prevent=""
        class="action-window"
    >
        <div class="prize-box container">
            <img
                @click="newsClickHandler('关闭', true)"
                class="icon-close"
                src="../../image/newVersion/icon_close.png"
                alt=""
            >
            <div class="prize-content">
                <p class="prize-title">{{'恭喜你获得了一张优惠劵'}}</p>
                <div
                    class="prize-info"
                    v-if="getCouponData"
                >
                    <div class="info-left">
                        <span class="price">
                            <span class="price-icon">￥</span>
                            <span class="price-count">{{parseInt(getCouponData.value || 0)}}</span>
                        </span>
                        <span class="limit">
                            <span class="desc">满{{parseInt(getCouponData.mininum || 0)}}可用</span>
                        </span>
                    </div>
                    <div class="info-right">
                        <span class="info-name">全场通用</span>
                        <span>{{ formatTime(getCouponData.end_time) }}过期</span>
                    </div>
                </div>
                <span
                    class="prize-btn"
                    @click="newsClickHandler('去使用')"
                >去使用</span>
            </div>
        </div>
        <!-- <div class="container xsqcon">
			<div class="close" @click="newsClickHandler"></div>
			<div class="img">
				<img class="xsq" src="../../image/new-guild.png" alt="" />
			</div>
			<div class="text-container">
				<div class="prize-show" v-if="getCouponData">
					<div class="prize-tip">
						<span>￥</span><span class="coupon-value">{{ getCouponData.value }}</span
						><span class="coupon-tip">满￥{{ getCouponData.mininum }}可用</span>
					</div>
					<div class="guild-btn" @click.stop.prevent="newsClickHandler">
						立即使用
					</div>
				</div>
			</div>
		</div> -->
    </div>
</template>

<script>
import {apiPath} from '../../common/js/config.js';
import myAjax from '../../common/js/request';
import {commonFn} from '../../common/js/common';
import dayjs from 'dayjs';
export default {
    name: 'newUserPop',
    data() {
        return {
            channel: commonFn.getParams()['channel'] || localStorage.getItem('channel') || ''
        };
    },
    computed: {
        isForceRegister() {
            return this.$store.state.isForceRegister;
        },
        getCouponData() {
            return this.$store.state.couponData;
        }
    },
    methods: {
        async newsClickHandler(tag, isClose = false) {
            tag && this.track(tag);
            this.$store.commit('setCouponPop', false);
            await myAjax
                .get(apiPath.clickCoupon)
                .then((res) => {})
                .catch((e) => {});
            /* 跳转闪测 */
            if (this.$route.path == '/seckill') {
                return false;
            } else if (this.$route.path != '/ScDetail' && this.$route.path != '/answerIndex') {
                if (commonFn.isFslpApp()) {
                    if (this.$route.path == '/usercateList') {
                        return;
                    }
                    if (this.$route.path == '/ScHotlist' && commonFn.getParams()['id'] == '12') {
                        return;
                    }
                }

                if (!isClose) {
                    this.$router.push({
                        path: `/scIndex`
                    });
                }
            }
            _hmt.push(['_trackPageview', '/new-lijishiyong']);
        },
        track(action = '', extend = '') {
            commonFn.addTrackEvent('优惠券待使用弹窗', action, extend);
        },
        formatTime(value) {
            return dayjs.unix(value).format('YYYY-MM-DD HH:mm');
        },
    }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '../../common/style/config.less';
/* 首页活动弹窗 */
.action-window {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    background: rgba(0, 0, 0, 0.7);
}

.action-window .container {
    width: auto !important;
    position: absolute;
    top: 50%;
    left: 50%;
    // width: 8.827rem;
    // height: 7.360rem;
    background: transparent;
    transform: translate(-50%, -50%);
    border-radius: 0.067rem 0.067rem;
}

.action-window .container img {
    vertical-align: middle;
}

.action-window .close {
    position: absolute;
    right: 0.267rem;
    top: 0.267rem;
    width: 0.400rem;
    height: 0.400rem;
    background: url(../../image/close-new-guild.png) no-repeat center center;
    background-size: 0.400rem 0.400rem;
}

.text-container {
    margin-top: -0.133rem;
    padding: 0.133rem 0.320rem 0.533rem;
    background: #e36052;
    color: #fff;
    border-bottom-left-radius: 0.107rem;
    border-bottom-right-radius: 0.107rem;
    .user-method {
        display: flex;
        justify-content: space-between;
        padding: 0.267rem 0;
        border-bottom: 1px dashed #eee;
        font-size: 0.320rem;
    }
    .prize-show {
        display: flex;
        justify-content: space-between;
        padding-top: 0.533rem;
        .guild-btn {
            width: 2.133rem;
            height: 0.907rem;
            background-color: #ffffff;
            border-radius: 0.107rem;
            font-size: 0.400rem;
            color: @mainColor;
            line-height: 0.907rem;
            text-align: center;
        }
        .prize-tip {
            display: inline-flex;
            align-items: baseline;
            font-size: 0.400rem;
            color: #fffefe;
        }
        .coupon-value {
            padding-left: 0.267rem;
            padding-right: 0.400rem;
            font-size: 0.960rem;
        }
        .coupon-tip {
            font-size: 0.320rem;
            color: rgba(255, 255, 255, 0.6);
        }
    }
}
.prize-box {
    padding-top: 1.067rem;
    text-align: center;
    .icon-close {
        width: 0.640rem;
        height: 0.640rem;
        position: absolute;
        top: 0;
        right: 0;
    }
    .prize-content {
        width: 7.147rem;
        height: 4.960rem;
        background: url('../../image/newVersion/bg_coupon.png') center/100% no-repeat;
        text-align: center;
        .prize-title {
            font-size: 0.480rem;
            color: #fff;
            font-family: STSongti-SC-Bold, STSongti-SC;
            font-weight: 700;
            text-align: center;
            padding-top: 0.373rem;
        }
        .prize-info {
            display: flex;
            align-items: center;
            padding: 0.480rem 0.480rem 0;
            .info-left {
                display: flex;
                width: 1.733rem;
                flex-direction: column;
                align-items: center;
                .price {
                    font-size: 0;
                    .price-icon {
                        font-size: 0.427rem;
                        color: #d90b0b;
                    }
                    .price-count {
                        font-size: 0.853rem;
                        color: #d90b0b;
                    }
                }
                .limit {
                    .desc {
                        font-size: 0.320rem;
                        color: #9e5c20;
                    }
                }
            }
            .info-right {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                margin-left: 0.213rem;
                // padding-top: 0.333rem;
                .info-name {
                    font-size: 0.427rem;
                    color: #7a420f;
                    text-align: left;
                    line-height: 0.587rem;
                    margin-bottom: 0.080rem;
                }
                .info-date {
                    font-size: 0.320rem;
                    color: #9e5c20;
                    margin-top: 0.080rem;
                    text-align: left;
                    line-height: 0.453rem;
                }
            }
        }
        .prize-btn {
            display: inline-block;
            width: 4.107rem;
            height: 1.013rem;
            line-height: 1.013rem;
            text-align: center;
            background: #ffffff;
            border-radius: 0.133rem;
            font-size: 0.400rem;
            color: #ec072a;
            position: absolute;
            bottom: 0.453rem;
            left: 50%;
            transform: translateX(-50%);
            &::after {
                content: '';
                position: absolute;
                width: 4rem;
                height: 0.907rem;
                border-radius: 0.080rem;
                border: 1px solid #ffd9a6;
                box-sizing: border-box;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// newUserPopV2.vue?05f2e428